import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 223-chevron-left
 * @see {GlyphIcon}
 */
const ChevronLeftIcon = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d="M22.41406,23.37866a.5.5,0,0,1,0,.70709L19.586,26.91425a.50007.50007,0,0,1-.70715,0L8.67151,16.70709a.99988.99988,0,0,1,0-1.41418L18.87885,5.08575a.50007.50007,0,0,1,.70715,0l2.82806,2.8285a.5.5,0,0,1,0,.70709L15.03564,16Z";
	}
}

export default ChevronLeftIcon;
